module.exports = "<span (click)=\"toggleUser()\">{{(params.data.active) ? 'Disable' : 'Enable' }}</span>"